'use strict';
import angular from 'angular';

angular.module('scheduleJobs.services', [])
    .factory('ScheduleJobsService', ['IORestangular', '$q', 'CoreRestAngular', 'Upload', 'AppConfig', function (IORestangular, $q, CoreRestAngular, Upload, AppConfig) {
        var workflowTypes = IORestangular.all('workflows/workflowTypes');
        var workflowActions = IORestangular.all('workflows/workflowActions');
        var queryKeys = IORestangular.all('cron/queryKeys');
        var jobGroups = IORestangular.all('jobs/groups');
        var jobGroup = IORestangular.all('jobs/group');
        var jobsForGroup = IORestangular.all('jobs/jobsForGroup');
        var job = IORestangular.all('jobs/job');
        var timeZones = CoreRestAngular.all('enums/timezones');
        var exportGroup = IORestangular.all('jobs/exportJobGroup');

        var getScheduledJobGroups = function () {
            return jobGroups.customGET(undefined, undefined, undefined, undefined);
        };

        var addJobGroup = function (jobGroupObj) {
            return jobGroup.customPOST(jobGroupObj, undefined, undefined, undefined);
        };

        var updateJobGroup = function (jobGroupObj) {
            return jobGroup.customPUT(undefined, undefined, jobGroupObj, undefined);
        };

        var deleteJobGroup = function (jobGroupObj) {
            return jobGroup.remove(jobGroupObj);
        };

        var getScheduledJobsByGroup = function (jobGroup) {
            return jobsForGroup.customGET(undefined, {group: jobGroup.id}, undefined, undefined);
        };

        var addJob = function (jobObj) {
            return job.customPOST(jobObj, undefined, undefined, undefined);
        };

        var updateJob = function (jobObj) {
            return job.customPUT(undefined, undefined, jobObj, undefined);
        };

        var deleteJob = function (jobObj) {
            return job.remove(jobObj);
        };

        var getWorkflowTypes = function () {
            return workflowTypes.customGET(undefined, undefined, undefined, undefined);
        };

        var getWorkflowActions = function () {
            return workflowActions.customGET(undefined, undefined, undefined, undefined);
        };

        var getQueryKeys = function () {
            return queryKeys.customGET(undefined, undefined, undefined, undefined);
        };

        var getTimeZones = function () {
            return timeZones.customGET(undefined, undefined, undefined, undefined);
        };

        var exportJobGroup = function (jobGroup) {
            return exportGroup.customGET(undefined, {group: jobGroup.id}, undefined, undefined);
        };

        var importJobGroup = function(customFile) {
            return Upload.upload({url: AppConfig.IO_API_URL + 'jobs/importJobGroup', file: customFile});
        };

        return {
            getScheduledJobGroups: getScheduledJobGroups,
            addJobGroup: addJobGroup,
            updateJobGroup: updateJobGroup,
            deleteJobGroup: deleteJobGroup,
            getScheduledJobsByGroup: getScheduledJobsByGroup,
            addJob: addJob,
            updateJob: updateJob,
            deleteJob: deleteJob,
            getWorkflowTypes: getWorkflowTypes,
            getWorkflowActions: getWorkflowActions,
            getQueryKeys: getQueryKeys,
            getTimeZones: getTimeZones,
            exportJobGroup : exportJobGroup,
            importJobGroup : importJobGroup
        };
    }]);